export default __webpack_public_path__ + "static/media/mainpic.3df4f3ca.png";